/**
 * Permet de mettre à jour un service
 * @type {string}
 */
export const SERVICE_POST = 'post'

/**
 * Rafraîchit les infos du service actif
 * @type {string}
 */
export const SERVICE_REFRESH = 'refresh'

/**
 * Transmet un service lié à un circuit
 * @type {string}
 */
export const SERVICE_PUT_CIRCUIT_SERVICE = 'putCircuitService'

/**
 * Ajouter un event au service actif
 * @type {string}
 */
export const SERVICE_POST_EVENT = 'postEvent'

/**
 * Ajouter un event PTI au service active
 * @type {string}
 */
export const SERVICE_POST_EVENT_PTI = 'postEventPti'
